import React from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  root: {
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const Header = ({ classes, children }) => {
  return(
    <Card className={classes.root}>
      <CardHeader title="Select a Receipt Type" />
      <div className={classes.row}>
        {children}
      </div>
    </Card>
  );
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Header.jsx